<template>
    <div cclass="pa-0 fill-height d-flex flex-column justify-center align-center text-center">

        <!-- Top Bar with Logo -->
        <div class="logo-container">
            <img src="@/assets/logo.svg" alt="Hubble STAR logo" />
        </div>

        <!-- Main Content -->
        <div class="main-container">
            <img src="@/assets/link-not-active.svg" class="mb-6" alt="Link not active illustration" />
            <h2 class="text-h6 font-weight-bold mb-2">Link Not Yet Active</h2>
            <p class="text-body-1">
                You’re trying to access the interview feedback form before the scheduled date and time.</p>
            <p>It will be available on <strong>{{ date }} at {{ time }}</strong>.
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: "InterviewNotActive",
    data() {
        return {
            date: "",
            time: "",
        }
    },
    created() {
        const date = new Date(atob(this.$route.query.data));
        let remainingSeconds = ((new Date().getTime() - date.getTime()) / 1000)
         if( remainingSeconds >= 0 ){
            this.$router.back()
         }
        const { formattedDate, formattedTime } = this.convertDateToDDMMYY(date);
        this.date = formattedDate,
        this.time = formattedTime;
    },
    methods: {
        convertDateToDDMMYY(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const formattedDate = `${day}/${month}/${year}`;

            // Format hh:mm AM/PM
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            const formattedTime = `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;

            console.log("Formatted Date:", formattedDate); // 10/07/2025
            console.log("Formatted Time:", formattedTime); // 07:15 PM (for example)
            return {
                formattedDate,
                formattedTime
            }
        }
    }
}
</script>
<style>
.logo-container {
    align-self: start;
    padding-left: 20px;
}

.logo-container>img {
    height: 100px;
    width: 200px;
    object-fit: contain;
}

.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    text-align: center;
}

.main-container>img {
    max-width: 600px;
}
</style>